<payarc-page-header [title]="'Merchant Profile'"></payarc-page-header>

<div class="pa-stack">
<payarc-inline-alert variant="bad" *ngIf="topErrorMessage">
  <div *ngFor="let msg of keys1">{{ msg }}</div>
</payarc-inline-alert>
<payarc-inline-alert variant="bad" *ngIf="!topErrorMessage && errorMsg">{{ errorMsg }}</payarc-inline-alert>

<payarc-section-card heading="Account Branding Information">
  <form [formGroup]="uploadForm" class="ab-grid">
    <payarc-form-field label="MID">
      <div class="ab-mid">
        <span>{{ activeUser?.mid }}</span>
        <button type="button" payarcButton="secondary" (click)="copy(activeUser?.mid)">{{ copyLabel }}</button>
      </div>
    </payarc-form-field>

    <payarc-form-field label="Branding logo" hint="File size should not exceed 2MB. File format should be png, jpg, or jpeg." controlId="brandingLogo">
      <button type="button" payarcButton="secondary" (click)="upload.click()">⬆ Upload logo</button>
      <input type="file" id="brandingLogo" #upload hidden (change)="onSelectFile($event, upload)" accept=".jpg,.png,.jpeg" formControlName="file">
      <span class="ab-filename" *ngIf="file">{{ file.name }}</span>
      <div class="ab-uploading" *ngIf="loadFlag"><img src="../../../assets/images/uploading.svg" alt=""></div>
      <img class="ab-logo-preview" *ngIf="logourl" [src]="logourl" alt="Branding logo">
    </payarc-form-field>

    <payarc-form-field label="Success redirect URL" [error]="sucessurl.value && sucessurl.invalid ? 'Not a valid URL' : ''" controlId="successUrl">
      <input class="pa-input" id="successUrl" name="sucessurl" type="text" [(ngModel)]="success_url" formControlName="sucessurl" placeholder="https://…">
    </payarc-form-field>

    <payarc-form-field label="Failure redirect URL" [error]="failureurl.value && failureurl.invalid ? 'Not a valid URL' : ''" controlId="failureUrl">
      <input class="pa-input" id="failureUrl" name="failureurl" type="text" [(ngModel)]="failure_url" formControlName="failureurl" placeholder="https://…">
    </payarc-form-field>

    <payarc-form-field label="Statement description" [required]="true" hint="This value will appear on your customer's credit card statement." controlId="statementDescription">
      <input class="pa-input" id="statementDescription" name="desc" type="text" [(ngModel)]="statement_descriptor" formControlName="desc" maxlength="25">
    </payarc-form-field>

    <payarc-form-field label="Customer Service Phone Number" hint="This number will appear on receipts emailed to the customer." controlId="csPhoneNumber"
      [error]="uploadForm.get('csPhoneNumber').invalid && uploadForm.get('csPhoneNumber').touched ? 'Phone number is invalid. Please enter a valid 10-digit number.' : ''">
      <input class="pa-input" id="csPhoneNumber" name="cs_phone_number" type="text" [(ngModel)]="csPhoneNumber" formControlName="csPhoneNumber" mask="(000) 000-0000" maxlength="25">
    </payarc-form-field>

    <payarc-form-field label="Capture address information">
      <div class="ab-radio-row">
        <label class="pa-radio"><input type="radio" name="addressyes" [(ngModel)]="is_address_optional" formControlName="addressyes" [value]="0"> Yes</label>
        <label class="pa-radio"><input type="radio" name="addressno" [(ngModel)]="is_address_optional" formControlName="addressno" [value]="1"> No</label>
      </div>
    </payarc-form-field>

    <div class="ab-footer">
      <app-loading-button (buttonClick)="save()" [disable]="disactiveimg || uploadForm.invalid" [loadFlag]="load" [buttonWidth]="'111px'" [buttonText]="'Save'"></app-loading-button>
    </div>
  </form>
</payarc-section-card>

<payarc-section-card heading="Business Information" *ngIf="cm_permission">
  <div class="ab-info-grid">
    <payarc-detail-card [flat]="true" [rows]="businessInfoRowsLeft"></payarc-detail-card>
    <payarc-detail-card [flat]="true" [rows]="businessInfoRowsRight"></payarc-detail-card>
  </div>
</payarc-section-card>

<app-bank-account-list *ngIf="cm_permission" [AccountData]="activeUser"></app-bank-account-list>
</div>
